import { useIsAdmin } from '@/features/access/useIsAdmin'
import { useAuthStore } from '@/features/auth/useAuthStore.js'
import { createNoAccessPath } from '@/features/noAccess/noAccess.utils.js'
import { decidePermission } from '@/features/permissions/permissionEngine.js'
import { logPermissionDecision } from '@/features/permissions/permissionDiagnostics.js'
import { getActiveClubId } from '@/features/router/useActiveClub.js'

function getRoutePermissionAction(to) {
  return [...(to.matched ?? [])].reverse().find(record => record.meta?.permissionAction)?.meta
    ?.permissionAction
}

function getRouteActiveClubId(to) {
  const activeClubId = to?.query?.activeClubId
  return Array.isArray(activeClubId) ? activeClubId[0] : activeClubId
}

export async function adminGuard(to, from, next) {
  const isAdmin = useIsAdmin()

  const forceAdmin = from.query.forceAdmin
  if (forceAdmin) {
    next()
    return
  }

  if (!isAdmin) {
    next('/no-access?reason=not-admin')
    return
  }

  const permissionAction = getRoutePermissionAction(to)

  if (!permissionAction) {
    next()
    return
  }

  const authStore = useAuthStore()
  const activeTenantId = getRouteActiveClubId(to) || getActiveClubId()
  const decision = decidePermission(permissionAction, {
    myDetails: authStore.myDetails,
    activeTenantId,
    surface: 'admin',
    route: to.fullPath,
  })

  if (decision.allowed) {
    next()
    return
  }

  logPermissionDecision('route_denied', decision, {
    route: to.fullPath,
  })
  next(
    createNoAccessPath({
      reason: 'permission-denied',
      action: permissionAction,
      returnUrl: to.fullPath,
    }),
  )
}
